import { ILoggedIn, IPaths, RootState } from '@checkout/state';
import * as React from 'react';
import { Fragment } from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { logOutRequest, toggleMembershipOverlay } from '../../../reducers/checkout';
import { Button } from '../../presentational';
import messages from './../../../i18n/base-en';
import * as Styles from './CheckoutMembershipModule.scss';

interface IOwnProps {}

interface IConnectedProps {
  loggedIn: ILoggedIn | null;
  pathnames: IPaths;
}

interface IConnectetDispatchProps {
  toggleMembershipOverlay: typeof toggleMembershipOverlay;
  logOutRequest: typeof logOutRequest;
}

type Props = IOwnProps & IConnectedProps & IConnectetDispatchProps & InjectedIntlProps;

class CheckoutMembershipModule extends React.Component<Props, {}> {

  handleMembershipOpen = () => {
    const { toggleMembershipOverlay: toggleOverlay } = this.props;
    toggleOverlay({ isOpen: true });
  }

  logout = () => {
    this.props.logOutRequest();
  }

  render() {
    const { loggedIn, pathnames, intl } = this.props;
    const { formatMessage } = intl;

    return (
      <Fragment>
        {loggedIn && (
          <div className={Styles.module}>
            <a href={pathnames.account} className={Styles.name}>{loggedIn.firstName}</a>
            <div className={Styles.logout}>
              <span className={Styles.label}>{formatMessage(messages.membership_not_your_account)}</span>
              <Button onClick={this.logout} type="button" variant="clear" size="medium" label={formatMessage(messages.membership_logout)} />
            </div>
          </div>
        )}
        {loggedIn === null && (
          <div className={Styles.module}>
            <span className={Styles.label}>{formatMessage(messages.membership_continue_as_guest)}</span>
            <Button
              onClick={this.handleMembershipOpen}
              type="button"
              variant="clear"
              size="medium"
              label={formatMessage(messages.membership_login_button_label)}
            />
          </div>
        )}
      </Fragment>
    );
  }
}

export default compose<React.ComponentClass<IOwnProps>>(
  injectIntl,
  connect<IConnectedProps, IConnectetDispatchProps>(
    (state: RootState) => ({
      loggedIn: state.checkout.loggedIn,
      pathnames: state.checkout.pathnames,
    }),
    {
      toggleMembershipOverlay,
      logOutRequest,
    },
  )
)(CheckoutMembershipModule);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/container/CheckoutMembershipModule/CheckoutMembershipModule.tsx